import { defineComponent as P, inject as y, computed as T, h as t, mergeProps as $, Fragment as R } from "vue";
import { tabsInjectionKey as B } from "./ghl-ui.es1106.js";
import { tabPaneProps as _ } from "./ghl-ui.es197.js";
import A from "./ghl-ui.es862.js";
import x from "./ghl-ui.es1003.js";
import { render as j } from "./ghl-ui.es985.js";
import S from "./ghl-ui.es859.js";
import { omit as k } from "./ghl-ui.es1058.js";
const I = Object.assign({
  internalLeftPadded: Boolean,
  internalAddable: Boolean,
  internalCreatedByPane: Boolean
}, k(_, ["displayDirective"])), q = P({
  __TAB__: !0,
  inheritAttrs: !1,
  name: "Tab",
  props: I,
  setup(a) {
    const {
      mergedClsPrefixRef: e,
      valueRef: l,
      typeRef: d,
      closableRef: i,
      tabStyleRef: f,
      addTabStyleRef: c,
      tabClassRef: o,
      addTabClassRef: b,
      tabChangeIdRef: r,
      onBeforeLeaveRef: n,
      triggerRef: h,
      handleAdd: v,
      activateTab: u,
      handleClose: C
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = y(B);
    return {
      trigger: h,
      mergedClosable: T(() => {
        if (a.internalAddable)
          return !1;
        const {
          closable: s
        } = a;
        return s === void 0 ? i.value : s;
      }),
      style: f,
      addStyle: c,
      tabClass: o,
      addTabClass: b,
      clsPrefix: e,
      value: l,
      type: d,
      handleClose(s) {
        s.stopPropagation(), !a.disabled && C(a.name);
      },
      activateTab() {
        if (a.disabled)
          return;
        if (a.internalAddable) {
          v();
          return;
        }
        const {
          name: s
        } = a, g = ++r.id;
        if (s !== l.value) {
          const {
            value: m
          } = n;
          m ? Promise.resolve(m(a.name, l.value)).then((p) => {
            p && r.id === g && u(s);
          }) : u(s);
        }
      }
    };
  },
  render() {
    const {
      internalAddable: a,
      clsPrefix: e,
      name: l,
      disabled: d,
      label: i,
      tab: f,
      value: c,
      mergedClosable: o,
      trigger: b,
      $slots: {
        default: r
      }
    } = this, n = i ?? f;
    return t("div", {
      class: `${e}-tabs-tab-wrapper`
    }, this.internalLeftPadded ? t("div", {
      class: `${e}-tabs-tab-pad`
    }) : null, t("div", Object.assign({
      key: l,
      "data-name": l,
      "data-disabled": d ? !0 : void 0
    }, $(
      {
        class: [`${e}-tabs-tab`, c === l && `${e}-tabs-tab--active`, d && `${e}-tabs-tab--disabled`, o && `${e}-tabs-tab--closable`, a && `${e}-tabs-tab--addable`, a ? this.addTabClass : this.tabClass],
        onClick: b === "click" ? this.activateTab : void 0,
        onMouseenter: b === "hover" ? this.activateTab : void 0,
        style: a ? this.addStyle : this.style
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.internalCreatedByPane ? this.tabProps || {} : this.$attrs
    )), t("span", {
      class: `${e}-tabs-tab__label`
    }, a ? t(R, null, t("div", {
      class: `${e}-tabs-tab__height-placeholder`
    }, " "), t(A, {
      clsPrefix: e
    }, {
      default: () => t(x, null)
    })) : r ? r() : typeof n == "object" ? n : j(n ?? l)), o && this.type === "card" ? t(S, {
      clsPrefix: e,
      class: `${e}-tabs-tab__close`,
      onClick: this.handleClose,
      disabled: d
    }) : null));
  }
});
export {
  q as default,
  I as tabProps
};
